export class JobsBoardApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @returns PaginatedJobsResponse
     * @throws ApiError
     */
    getAllJobs({ limit = 10, offset, organizationName, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/jobs-board/all',
            query: {
                'limit': limit,
                'offset': offset,
                'organizationName': organizationName,
            },
        });
    }
    /**
     * @returns Job
     * @throws ApiError
     */
    createJobForOrganization({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/jobs-board/create/{organization}',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Job
     * @throws ApiError
     */
    updateJobForOrganization({ id, requestBody, }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/jobs-board/update/{organization}/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    deleteJobForOrganization({ id, organization, }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/jobs-board/delete/{organization}/{id}',
            path: {
                'id': id,
                'organization': organization,
            },
        });
    }
    /**
     * @returns Job
     * @throws ApiError
     */
    getJob({ id, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/jobs-board/organization/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns PaginatedJobsResponse
     * @throws ApiError
     */
    getJobsByOrganization({ limit = 10, offset, organizationName, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/jobs-board/organization',
            query: {
                'limit': limit,
                'offset': offset,
                'organizationName': organizationName,
            },
        });
    }
    /**
     * @returns PaginatedJobsResponse
     * @throws ApiError
     */
    searchJobs({ title, hourlyPayInCents, specialty, shift, license, benefits, education, organizationId, limit = 50, includeArchived = false, includeUnpublished = false, offset, employmentType, locationType, location, payFrequency, fromPay, toPay, organizationName, region, locality, createdById, status, radius = 25, fromLocation, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/jobs-board/search/all',
            query: {
                'title': title,
                'hourlyPayInCents': hourlyPayInCents,
                'specialty': specialty,
                'shift': shift,
                'license': license,
                'benefits': benefits,
                'education': education,
                'organizationId': organizationId,
                'limit': limit,
                'includeArchived': includeArchived,
                'includeUnpublished': includeUnpublished,
                'offset': offset,
                'employmentType': employmentType,
                'locationType': locationType,
                'location': location,
                'payFrequency': payFrequency,
                'fromPay': fromPay,
                'toPay': toPay,
                'organizationName': organizationName,
                'region': region,
                'locality': locality,
                'createdById': createdById,
                'status': status,
                'radius': radius,
                'fromLocation': fromLocation,
            },
        });
    }
    /**
     * @returns JobCreatorsListResponseDto
     * @throws ApiError
     */
    geCreatedByList() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/jobs-board/createdByList',
        });
    }
    /**
     * @returns Job
     * @throws ApiError
     */
    createJob({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/jobs-board',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedJobsResponse
     * @throws ApiError
     */
    getPublishedJobs({ limit = 10, offset, organizationName, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/jobs-board',
            query: {
                'limit': limit,
                'offset': offset,
                'organizationName': organizationName,
            },
        });
    }
    /**
     * @returns Job
     * @throws ApiError
     */
    updateJob({ id, requestBody, }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/jobs-board/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Job
     * @throws ApiError
     */
    getPublishedJob({ id, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/jobs-board/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns Job
     * @throws ApiError
     */
    publishJob({ id, }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/jobs-board/{id}/publish',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns Job
     * @throws ApiError
     */
    unpublishJob({ id, }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/jobs-board/{id}/unpublish',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns Job
     * @throws ApiError
     */
    archiveJob({ id, }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/jobs-board/{id}/archive',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns Job
     * @throws ApiError
     */
    unarchiveJob({ id, }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/jobs-board/{id}/unarchive',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Track Job click and redirect to job application link
     * @returns any
     * @throws ApiError
     */
    handleClick({ id, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/jobs-board/{id}/handleClick',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns PaginatedJobsResponse
     * @throws ApiError
     */
    searchPublishedJobs({ title, hourlyPayInCents, specialty, shift, license, benefits, education, organizationId, limit = 50, includeArchived = false, includeUnpublished = false, offset, employmentType, locationType, location, payFrequency, fromPay, toPay, organizationName, region, locality, createdById, status, radius = 25, fromLocation, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/jobs-board/search',
            query: {
                'title': title,
                'hourlyPayInCents': hourlyPayInCents,
                'specialty': specialty,
                'shift': shift,
                'license': license,
                'benefits': benefits,
                'education': education,
                'organizationId': organizationId,
                'limit': limit,
                'includeArchived': includeArchived,
                'includeUnpublished': includeUnpublished,
                'offset': offset,
                'employmentType': employmentType,
                'locationType': locationType,
                'location': location,
                'payFrequency': payFrequency,
                'fromPay': fromPay,
                'toPay': toPay,
                'organizationName': organizationName,
                'region': region,
                'locality': locality,
                'createdById': createdById,
                'status': status,
                'radius': radius,
                'fromLocation': fromLocation,
            },
        });
    }
    /**
     * @returns JobCityDto
     * @throws ApiError
     */
    getJobLocalities({ pageSize, page, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/jobs-board/localities',
            query: {
                'pageSize': pageSize,
                'page': page,
            },
        });
    }
    /**
     * @returns JobCompanyDto
     * @throws ApiError
     */
    getJobCompanies({ pageSize, page, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/jobs-board/companies',
            query: {
                'pageSize': pageSize,
                'page': page,
            },
        });
    }
    /**
     * @returns JobCompanyDto
     * @throws ApiError
     */
    getTopJobCompanies() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/jobs-board/top-companies',
        });
    }
    /**
     * @returns JobCategoriesResponseDto
     * @throws ApiError
     */
    getCategories() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/jobs-board/categories',
        });
    }
    /**
     * @returns number
     * @throws ApiError
     */
    incrementJobApplications({ id, }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/jobs-board/{id}/apply',
            path: {
                'id': id,
            },
        });
    }
}
